import Header from 'app/components/Header';
import useHistory from 'app/modules/tailor/hooks/useHistory';

const Tooltip = () => {
  const { location } = useHistory();

  return (
    <div
      id="ostro-tailor-tooltip-container"
      className="flex flex-col grow"
    >
      <Header className="py-5 px-7" />
      <div
        id="ostro-tailor-tooltip-content"
        className="flex flex-col py-2 px-7"
      >
        <h1 className="text-2xl mb-4">{location.state?.anchor}</h1>
        <p className="text-sm">{location.state?.content}</p>
      </div>
    </div>
  );
};

export default Tooltip;
